export default [
  {
    path: '/pages/complaint/complaint',
    name: 'complaint',
    meta: {
        title: "举报"
      },
      component: () => import('../pages/complaint/complaint.vue')
  },
  {
    path: '/pages/complaint/complaintContent/complaintContent',
    name: 'complaintContent',
    meta: {
        title: "举报内容",
        keepAlive: false
      },
      component: () => import('../pages/complaint/complaintContent/complaintContent.vue')
  }
]